import t from '../common/text';

export default (data) => {
    return `
    <div class="Form ConfirmLink">
      <div class="FormName">ConfirmLink</div>
      <div class="Explain">
        ${t('confirm.explain')}
      </div>      
      <a 
        class="Extra ResendLink"
        href="#"
      >
        ${t('confirm.resend')}
      </a>
      <div class="Message"></div>          
    </div>
  `;
};
